<template>
  <div class="zyc-tabs-pane" :ariaLabel="label" :style="{ height: (height - 265) + 'px' }">
    <slot></slot>
  </div>
</template>
<script>
  /**
  * 标签页内容容器
  */
  export default {
    name: 'zycTabPane',
    props: {
      label: {
        type: String,
        default: ''
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
        height: 0
      }
    },
    mounted() {

    },
    created() {
      this.onresize()
      window.addEventListener('resize', this.onresize)
    },
    methods: {
      onresize(event) {
        this.height = window.innerHeight
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/tabs/tabPane.vue